import { AccountStatus } from '@ivy-monorepo/shared'
import MultiSelectFilter from './MultiSelectFilter'

const ACCOUNT_STATUS_OPTIONS = Object.values(AccountStatus).map(status => ({ value: status, label: status }))

interface AccountStatusFilterProps {
  selectedStatuses: AccountStatus[]
  onChange: (statuses: AccountStatus[]) => void
}

const AccountStatusFilter = ({ selectedStatuses, onChange }: AccountStatusFilterProps) => (
  <MultiSelectFilter
    title="Status"
    options={ACCOUNT_STATUS_OPTIONS}
    selected={selectedStatuses}
    fallback={[AccountStatus.Active]}
    onChange={onChange}
  />
)

export default AccountStatusFilter
